import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import startCase from 'lodash/startCase';
import lowerCase from 'lodash/lowerCase';


import { tyroSetQuestionAnswer } from '../../actions';
import TyroModalButtonGroup from './TyroModalButtonGroup';


class TyroModalQuestion extends Component {
  constructor(props) {
    super(props);
    this.handleOptionClick = this.handleOptionClick.bind(this);
  }

  handleOptionClick(option) {
    const { tyroSetQuestionAnswer } = this.props;
    tyroSetQuestionAnswer(option);
  }

  render() {
    const { message = "", options = [] } = this.props;

    return (
      <div>
        <div className="ui basic segment marginless">
          <p>{message}</p>
        </div>
        <TyroModalButtonGroup>
          {(options || []).map((option, index) => (
            <div className="ui basic button" key={index} onClick={() => this.handleOptionClick(option)}>{startCase(lowerCase(option))}</div>
          ))}
        </TyroModalButtonGroup>
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    tyroSetQuestionAnswer
  }, dispatch);
}


export default connect(null, mapDispatchToProps)(TyroModalQuestion);